import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className='Footer'>
            <p>Build By Ruhul Amin Parvez</p>
        </div>
    );
};

export default Footer;